// 3rd-party
import React from 'react';

// Components
import { PrimaryButton } from '../buttons';
import Modal from '@/views/components/modals/AccessibleModal';
import { Typography } from '@capintel/component-lib/typography';
import { Stack } from '@capintel/component-lib/stack';

// Utils
import { FormattedMessage } from '../../../utils/i18n';

// Assets
import confirmCheck from '../../../images/confirm-check.svg';

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
  showModal: boolean;
};

class ShareEmailConfirmationModal extends React.PureComponent<Props> {
  render() {
    const { onCancel, showModal, onConfirm } = this.props;

    return (
      <Modal show={showModal} className="invite-email-confirm-modal" onHide={onCancel} dialogClassName="modal-dialog-centered">
        <Modal.Header className="d-flex flex-column align-items-center">
          <Stack gap="400">
            <i className="icon-cross" onClick={onCancel} />
            <img className="confirm-check" src={confirmCheck} alt="" />
            <Typography variant="headerLg" as="h1">
              <FormattedMessage id="ShareEmailConfirmation.Title" />
            </Typography>
            <Typography variant="bodyMdRegular" as="p">
              <FormattedMessage id="ShareEmailConfirmation.Text" />
            </Typography>
          </Stack>
        </Modal.Header>

        <Modal.Footer className="d-flex flex-column align-items-center">
          <PrimaryButton className="submit-button" onClick={onConfirm}>
            <FormattedMessage id="Common.Done" />
          </PrimaryButton>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ShareEmailConfirmationModal;
